import { Card, CardBody, CardHeader, Skeleton } from '@heroui/react';
import { BlobsBackground } from '@milestone-portal/ui/BlobsBackground/BlobsBackground';
import { DesktopContainer } from '@milestone-portal/ui/DesktopContainer/DesktopContainer';
import { Footer } from '@milestone-portal/ui/Footer/Footer';

export function DesktopNftDetailSkeleton() {
  return (
    <div className="flex w-full flex-col">
      <BlobsBackground />
      <DesktopContainer>
        <div className="flex px-8 py-4">
          <Skeleton className="h-12 w-1/12 rounded-lg" />
          <Skeleton className="ml-auto h-12 w-2/12 rounded-lg" />
        </div>
        <div className="flex h-[680px] flex-row gap-4 overflow-hidden p-8">
          <Card shadow="none">
            <CardBody className="flex size-[600px] items-center justify-center overflow-hidden">
              <Skeleton className="size-[512px] rounded-lg" />
            </CardBody>
          </Card>
          <div className="flex flex-1 flex-col gap-4">
            <div className="flex items-center justify-between">
              <Skeleton className="h-8 w-48 rounded-lg" />
              <div className="flex items-center gap-2">
                <Skeleton className="size-10 rounded-lg" />
                <Skeleton className="size-10 rounded-lg" />
                <Skeleton className="size-10 rounded-lg" />
                <Skeleton className="size-10 rounded-lg" />
              </div>
            </div>

            <div className="grid grid-cols-1 gap-4 2xl:grid-cols-2">
              <Card shadow="none">
                <CardBody className="flex flex-row gap-4 overflow-hidden">
                  <div className="flex !w-[48px] items-center justify-center sm:!w-[64px]">
                    <Skeleton className="bg-default-500 !size-[48px] rounded-full p-[2px] sm:!size-[64px]" />
                  </div>
                  <div className="flex flex-col justify-center gap-2">
                    <Skeleton className="h-6 w-32 rounded-lg" />
                    <Skeleton className="text-default-600 h-4 w-24 rounded-lg" />
                  </div>
                </CardBody>
              </Card>
              <Card shadow="none">
                <CardBody className="flex flex-row gap-4 overflow-hidden">
                  <div className="flex !w-[48px] items-center justify-center sm:!w-[64px]">
                    <Skeleton className="bg-default-500 !size-[48px] rounded-full p-[2px] sm:!size-[64px]" />
                  </div>
                  <div className="flex flex-col justify-center gap-2">
                    <Skeleton className="h-6 w-32 rounded-lg" />
                    <Skeleton className="text-default-600 h-4 w-24 rounded-lg" />
                  </div>
                </CardBody>
              </Card>
            </div>
            <div className="flex flex-1 flex-row gap-4 overflow-hidden">
              <Card className="w-1/2" shadow="none">
                <CardHeader className="hidden flex-row gap-2 xl:flex">
                  <Skeleton className="h-6 w-40 rounded-lg" />
                </CardHeader>
                <CardBody className="overflow-auto">
                  <div className="flex flex-col gap-2">
                    <Skeleton className="h-4 w-full rounded-lg" />
                    <Skeleton className="h-4 w-full rounded-lg" />
                    <Skeleton className="h-4 w-3/4 rounded-lg" />
                  </div>
                </CardBody>
              </Card>
              <Card className="w-1/2" shadow="none">
                <CardHeader>
                  <Skeleton className="h-6 w-32 rounded-lg" />
                </CardHeader>
                <CardBody>
                  <div className="flex flex-col gap-3">
                    <Skeleton className="h-4 w-full rounded-lg" />
                    <Skeleton className="h-4 w-full rounded-lg" />
                    <Skeleton className="h-4 w-3/4 rounded-lg" />
                  </div>
                </CardBody>
              </Card>
            </div>
          </div>
        </div>
        <div className="px-8 pb-8">
          <Card shadow="none">
            <CardHeader>
              <Skeleton className="h-6 w-32 rounded-lg" />
            </CardHeader>
            <CardBody>
              <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4">
                {Array.from(Array(4).keys()).map((i) => (
                  <div className="flex flex-col gap-2" key={i}>
                    <Skeleton className="h-5 w-24 rounded-lg" />
                    <Skeleton className="h-4 w-full rounded-lg" />
                  </div>
                ))}
              </div>
            </CardBody>
          </Card>
        </div>
        <div className="grid grid-cols-1 gap-8 px-8 pb-8 2xl:grid-cols-2 2xl:gap-4">
          <Card shadow="none">
            <CardHeader>
              <Skeleton className="h-6 w-32 rounded-lg" />
            </CardHeader>
            <CardBody>
              <div className="flex flex-col gap-3">
                <Skeleton className="h-12 w-full rounded-lg" />
                <Skeleton className="h-12 w-full rounded-lg" />
              </div>
            </CardBody>
          </Card>
          <Card shadow="none">
            <CardHeader>
              <Skeleton className="h-6 w-32 rounded-lg" />
            </CardHeader>
            <CardBody>
              <div className="flex flex-col gap-3">
                <Skeleton className="h-12 w-full rounded-lg" />
                <Skeleton className="h-12 w-full rounded-lg" />
              </div>
            </CardBody>
          </Card>
        </div>
      </DesktopContainer>
      <Footer />
    </div>
  );
}
